import * as React from "react";
import { GoogleMap, Marker, Polygon, withGoogleMap } from "react-google-maps";
import { IStore, ITerritory } from "../../../../Models/Models";

class ItemMap extends React.Component {
  private googleMap: GoogleMap = null;
  private mapBounds = {
      east: 0,
      north: 0,
      south: 0,
      west: 0,
  };
  private latArray: Array<number> = [];
  private lngArray: Array<number> = [];
  private item: any = null; // either IStore or ITerritory - cannot use union type here
  private mapHeight = 32;
  private mapWidth = 32;
  private defaultMapZoom = 0;
  private googleMapOptions = {
      disableDefaultUI: true,
  };
  private defaultMapCenter = {
      // gets overridden depending on object type
      lat: 0,
      lng: 0,
  };
  private polygonCoordinates: any[] = [];
  private markerIcon = null;
  private mapData = null;
  /**
   *
   */
  constructor(props) {
      super(props);
      this.item = props.item;
  }

  public render() {
      this.setDefaultMapZoom();

      if (this.isStore(this.item)) {
          this.setDefaultMapCenter();
          this.setMarkerIcon();
      } else if (this.isTerritory(this.item)) {
          this.getTerritoryMapData();
          this.getDefaultMapCenterTerritory();
      }

      if (this.isStore(this.item)) {
          this.mapData = (
              <Marker
                  icon={this.markerIcon}
                  key={this.item.id}
                  position={this.defaultMapCenter}
              ></Marker>
          );
      } else if (this.isTerritory(this.item)) {
          this.mapData = <Polygon paths={this.polygonCoordinates}></Polygon>;
      }

      const mapObj = (
          <GoogleMap
              defaultZoom={this.defaultMapZoom}
              defaultCenter={this.defaultMapCenter}
              options={this.googleMapOptions}
              ref={(map): GoogleMap => this.setGoogleMap(map)}
          >
              {this.mapData}
          </GoogleMap>
      );

      return <div>{mapObj}</div>;
  }

  private setGoogleMap = (mapObj: GoogleMap): any => {
      if (mapObj) {
          this.googleMap = mapObj;
          if (this.isTerritory(this.item)) {
              this.googleMap.fitBounds(this.mapBounds);
          }
      //console.log("Google Map: ", this.googleMap);
      }
  };

  // private resizeMap = (): void => {
  //     console.log("RESIZING");
  //     setTimeout((): void => {
  //         google.maps.event.trigger(
  //             this.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
  //             'resize'
  //         );
  //     }, 500);
  // }

  private setMarkerIcon = (): void => {
      if (this.isStore(this.item)) {
          this.markerIcon = {
              url: this.item.iconPath,
              size: {
                  width: this.mapWidth,
                  height: this.mapHeight,
              },
              anchor: {
                  x: this.mapWidth / 2,
                  y: this.mapHeight / 2,
              },
              scaledSize: {
                  width: this.mapWidth,
                  height: this.mapHeight,
              },
          };
      } else {
          this.markerIcon = null;
      }
  };

  private setDefaultMapZoom = (): void => {
      this.defaultMapZoom = 9;
  };

  private setDefaultMapCenter = (): void => {
      if (this.isStore(this.item)) {
          this.defaultMapCenter.lat = this.item.latitude;
          this.defaultMapCenter.lng = this.item.longitude;
      }
  };

  private getDefaultMapCenterTerritory = (): void => {
      if (this.isTerritory(this.item)) {
          this.mapBounds.east = Math.max(...this.lngArray);
          this.mapBounds.west = Math.min(...this.lngArray);
          this.mapBounds.south = Math.min(...this.latArray);
          this.mapBounds.north = Math.max(...this.latArray);

          const latSum = this.latArray.reduce((a: number, b: number): number => {
              return a + b;
          });
          const lngSum = this.lngArray.reduce((a: number, b: number): number => {
              return a + b;
          });

          this.defaultMapCenter.lat = latSum / this.latArray.length;
          this.defaultMapCenter.lng = lngSum / this.lngArray.length;
      }
  };

  private getTerritoryMapData = (): void => {
      if (this.isTerritory(this.item)) {
          if (this.item.spatialObject.coordinates.length <= 1) {
              // single polygon

              for (
                  let i = 0;
                  i < this.item.spatialObject.coordinates[0].length;
                  i++
              ) {
                  const latLngObj: { lat: number; lng: number } = {
                      lat: this.item.spatialObject.coordinates[0][i][1],
                      lng: this.item.spatialObject.coordinates[0][i][0],
                  };
                  this.latArray.push(latLngObj.lat);
                  this.lngArray.push(latLngObj.lng);
                  this.polygonCoordinates.push(latLngObj);
              }
          } else {
              if (this.item.spatialObject.type === "MultiPolygon") {
                  for (let i = 0; i < this.item.spatialObject.coordinates.length; i++) {
                      for (
                          let j = 0;
                          j < this.item.spatialObject.coordinates[i][0].length;
                          j++
                      ) {
                          const latLngObj: { lat: number; lng: number } = {
                              lat: this.item.spatialObject.coordinates[i][0][j][1],
                              lng: this.item.spatialObject.coordinates[i][0][j][0],
                          };
                          this.latArray.push(latLngObj.lat);
                          this.lngArray.push(latLngObj.lng);
                          this.polygonCoordinates.push(latLngObj);
                      }
                  }
              } else {
                  for (let i = 0; i < this.item.spatialObject.coordinates.length; i++) {
                      for (
                          let j = 0;
                          j < this.item.spatialObject.coordinates[i].length;
                          j++
                      ) {
                          const latLngObj: { lat: number; lng: number } = {
                              lat: this.item.spatialObject.coordinates[i][j][1],
                              lng: this.item.spatialObject.coordinates[i][j][0],
                          };
                          this.latArray.push(latLngObj.lat);
                          this.lngArray.push(latLngObj.lng);
                          this.polygonCoordinates.push(latLngObj);
                      }
                  }
              }
          }
      }
  };

  private isStore(item: IStore): item is IStore {
      return (item as IStore).ssid !== undefined;
  }
  private isTerritory(item: ITerritory): item is ITerritory {
      return (item as ITerritory).territoryType !== undefined;
  }
}

// const onMapIdleFunc = (): void => {
//     //map.fitBounds({ ...mapBounds });
//     const bounds = map.getBounds();
//     map.fitBounds(bounds);
//     console.log("fitting bounds");
// };

export default withGoogleMap(ItemMap);
